<template>
	<div class="right-panel">
		<div class="chat-header">
			<h3>🤖 科学AI助手</h3>
		</div>
		<div class="chat-content" ref="chatContent">
			<div v-for="(msg, idx) in chatList" :key="idx" class="msg-item" :class="msg.role">
				<div class="avatar">{{ msg.role === 'student' ? '👨‍🎓' : '🤖' }}</div>
				<div class="msg-content">
					<div v-if="msg.time" class="msg-time">{{ formatTime(msg.time) }}</div>
					<div v-for="(item, index) in msg.content.split('\n')" :key="`follow-msg-${index}`">
						<div class="">{{item}} </div>

					</div>
				</div>
			</div>
		</div>
		<div class="chat-input">
			<RecordAudio @record-result="inputMsg = $event" :disabled="isLocked" />
			<input v-model="inputMsg" @keyup.enter="sendMsg" placeholder="输入问题..." :disabled="isLocked" />
			<button @click="sendMsg" class="send-btn" :disabled="isLocked || !inputMsg.trim()">发送</button>
		</div>
	</div>
</template>

<script>
	import RecordAudio from '../../components/RecordAudio.vue'
	import {
		checkSensitiveWord
	} from './studentClass.js'

	export default {
		components: {
			RecordAudio
		},
		props: {
			classInfo: Object,
			isClassEnded: Boolean,
			isLocked: Boolean,
			schoolId: [String, Number],
			courseClassId: [String, Number],
			studentId: [String, Number],
			studentName: String
		},
		data() {
			return {
				chatList: [],
				inputMsg: '',
				isAIApiProcessing: false,
				hasSavedConversationId: false
			}
		},
		created() {
			this.loadHistoryChat()
		},
		methods: {
			formatTime(t) {
				if (!t) return ''
				const d = new Date(t)
				return d.toLocaleString()
			},
			scrollBottom() {
				this.$nextTick(() => {
					const el = this.$refs.chatContent
					if (el) el.scrollTop = el.scrollHeight
				})
			},

			// 加载历史
			async loadHistoryChat() {
				try {
					const res = await this.API.get(this.API.school.getWithRoleList, {
						schoolId: this.schoolId,
						courseClassId: this.courseClassId,
						studentId: this.studentId
					})
					if (res.data.code === 200 && res.data.data.length) {
						this.chatList = res.data.data.map(i => ({
							role: i.role,
							content: i.content,
							time: i.createTime
						}))
					} else {
						this.chatList = [{
							role: 'ai',
							content: '你好！我是AI实验助手～',
							time: Date.now()
						}]
					}
					this.scrollBottom()
				} catch (e) {
					this.chatList = [{
						role: 'ai',
						content: '你好！我是AI实验助手～'
					}]
				}
			},

			// 接收教师消息
			receiveTeacherMsg(msg) {
				if (!msg) return
				if (msg.type === 'text' || !msg.type) {
					const exist = this.chatList.some(x => x.msgId === msg.msgId)
					if (!exist) {
						this.chatList.push({
							role: msg.role,
							content: msg.content,
							time: msg.time,
							msgId: msg.msgId
						})
						this.scrollBottom()
					}
				}
			},
			// 发送消息（给左侧工具调用）
			async sendMsg() {
				console.log('shortcutText', this.inputMsg)
				const content = (this.inputMsg || '').trim()
				if (!content || this.isLocked || this.isAIApiProcessing) return

				const check = checkSensitiveWord(content, this.courseClassId, localStorage.getItem('studentInfo'))
				if (check.isSensitive) {
					this.$message.error(`包含敏感词：${check.word}`)
					return
				}

				this.chatList.push({
					role: 'student',
					content,
					time: Date.now()
				})
				this.inputMsg = ''
				this.scrollBottom()

				await this.forPostStudentChat(content, 'student')
				const ai = await this.callAIApi(content)
				if (ai) await this.forPostStudentChat(ai.fullContent, 'ai')
			},

			// AI流式
			async callAIApi(inputText) {
				this.isAIApiProcessing = true;
				let publicPath = '';
				var isVue=this.API.isVue
				const pathParts = window.location.pathname.split('/');
				if(isVue==1){
					if(pathParts[1]=='test'){
						publicPath='/test'
					}
				}
				if(isVue==2){
					publicPath = '/api';
				}
				if(isVue==4){
					publicPath='/v1/api'
				}
				if(isVue==5){
					publicPath='/v1'
				}
				const url = publicPath + "/sys/school/class/student/coze/stream";

				try {
					const aiMsgIndex = this.chatList.length;
					this.chatList.push({
						role: "ai",
						content: "",
						time: Date.now(),
						msgId: `ai-${Date.now()}`
					});
					this.scrollBottom();

					let fullContent = "";
					let tokenInfo = {
						inputTokens: 0,
						outputTokens: 0,
						totalTokens: 0
					};
					let conversationId = null;

					const token = localStorage.getItem('token');
					const res = await fetch(url, {
						method: "POST",
						headers: {
							"Content-Type": "application/json",
							Authorization: token || ""
						},
						body: JSON.stringify({
							question: inputText,
							courseClassId: this.courseClassId,
							studentId: this.studentId
						})
					});

					const reader = res.body.getReader();
					const decoder = new TextDecoder();
					let buffer = "";

					while (true) {
						const {
							done,
							value
						} = await reader.read();
						if (done) break;

						buffer += decoder.decode(value, {
							stream: true
						});
						const lines = buffer.split("\n");
						buffer = lines.pop() || "";

						let currentEvent = "";
						for (const line of lines) {
							const trimLine = line.trim();
							if (!trimLine) continue;

							if (trimLine.startsWith("event:")) {
								currentEvent = trimLine.replace("event:", "").trim();
								continue;
							}
							if (trimLine.startsWith("data:")) {
								const jsonStr = trimLine.replace("data:", "").trim();
								if (jsonStr === "[DONE]" || jsonStr === '"[DONE]"') continue;

								try {
									const data = JSON.parse(jsonStr);

									if (currentEvent === "conversation.chat.created" && data.conversation_id) {
										if (!conversationId) {
											conversationId = data.conversation_id;
											console.log("获取到扣子会话ID：", conversationId);
											this.saveConversationId(conversationId);
										}
									}

									if (currentEvent === "conversation.message.delta" && data.content) {
										fullContent += data.content;
										this.$set(this.chatList, aiMsgIndex, {
											...this.chatList[aiMsgIndex],
											content: fullContent
										});
										this.scrollBottom();
									}

									if (currentEvent === "conversation.chat.completed" && data.usage) {
										tokenInfo.inputTokens = data.usage.input_count || 0;
										tokenInfo.outputTokens = data.usage.output_count || 0;
										tokenInfo.totalTokens = data.usage.token_count || 0;
									}
								} catch (e) {}
							}
						}
					}

					this.$set(this.chatList, aiMsgIndex, {
						...this.chatList[aiMsgIndex],
						tokenInfo
					});

					return {
						fullContent: fullContent,
						inputTokens: tokenInfo.inputTokens,
						outputTokens: tokenInfo.outputTokens
					};
				} catch (err) {
					console.error("AI错误：", err);
					return null;
				} finally {
					this.isAIApiProcessing = false;
				}
			},

			async saveConversationId(conversationId) {
				if (this.hasSavedConversationId) return;
				try {
					await this.API.post(this.API.school.saveConversationId, {
						courseClassId: this.courseClassId,
						studentId: this.studentId,
						conversationId: conversationId
					});
					console.log("会话ID已保存至数据库");
					this.hasSavedConversationId = true;
				} catch (e) {
					console.error("保存会话ID失败", e);
				}
			},

			// 上报聊天
			async forPostStudentChat(content, role) {
				try {
					await this.API.post(this.API.school.postStudentChat, {
						schoolId: Number(this.schoolId),
						courseClassId: this.courseClassId,
						studentId: Number(this.studentId),
						studentName: this.studentName,
						question: content,
						role: role
					})
					return true
				} catch (e) {
					return false
				}
			}
		}
	};
</script>

<style scoped>
	.right-panel {
		flex: 1;
		background: #fff;
		border-radius: 20px;
		padding: 20px;
		display: flex;
		flex-direction: column;
	}

	.chat-header {
		border-bottom: 1px dashed #eee;
		padding-bottom: 10px;
		margin-bottom: 10px;
	}

	.chat-content {
		flex: 1;
		overflow-y: auto;
		padding: 10px;
	}

	.msg-item {
		display: flex;
		margin: 12px 0;
		max-width: 80%;
	}

	.msg-item.student {
		flex-direction: row-reverse;
		margin-left: auto;
	}

	.avatar {
		font-size: 24px;
		margin: 0 8px;
	}

	.msg-content {
		background: #f3f4f6;
		padding: 12px 16px;
		border-radius: 16px;
	}

	.msg-item.student .msg-content {
		background: #667eea;
		color: #fff;
	}

	.chat-input {
		display: flex;
		gap: 10px;
		margin-top: 10px;
		align-items: center;
	}

	.chat-input input {
		flex: 1;
		height: 44px;
		border: 1px solid #eee;
		border-radius: 22px;
		padding: 0 16px;
	}

	.send-btn {
		background: #667eea;
		color: #fff;
		border: none;
		padding: 0 20px;
		height: 44px;
		border-radius: 22px;
	}
</style>